import { jwtDecode } from 'jwt-decode';
import moment from 'moment';

class User {

  setUser (user) {
    if (user) {
      user.permissions = [];
      if (user.roles && !user.locations) {
        user.permissions = user.roles[0] ?
        user.roles[0].permissions.map((perm) => {
          return perm.name
        }) : [];
      }

      try {
        if (user.locations.length) {
          user.permissions.push('location_user');
        }
      } catch (e) {

      }

      try {
        if (user.channels.length) {
          user.permissions.push('channel_user');
          user.permissions.push('location_management');
          user.permissions.push('location_rate_management');
          user.permissions.push('location_booking_conditions');
          user.permissions.push('locationFee_list');
          user.permissions.push('locationPhoto_list');
          user.permissions.push('amenity_list');
          user.permissions.push('extraFields_list');
          user.permissions.push('locationRate_adjustment_list');
          user.permissions.push('cancellationPolicy_list');
          user.permissions.push('longTermDiscount_list');
          user.permissions.push('blackoutDate_list');
          user.permissions.push('channelParkingRate_list');
          user.permissions.push('channelRoomRate_list');
          user.permissions.push('locationBundleRate_list');
          user.permissions.push('locationBundle_list');
          user.permissions.push('locationParkingType_list');
          user.permissions.push('locationRoomType_list');
          user.permissions.push('report_commission');
        }
      } catch (e) {

      }
    }
    localStorage.setItem("__user__", JSON.stringify(user));
  }

  getUser () {
    let user = localStorage.getItem("__user__");

    if(user == "null") return null;
    return JSON.parse(user);
  }

  setToken (token) {
    localStorage.setItem("__token__", token);
  }

  getToken () {
    let token = localStorage.getItem("__token__");

    if(token == "null") return null;
    return token;
  }

  decodeToken() {
    const token = this.getToken();
    if (!token) return null;
    try {
      const decoded = jwtDecode(token);
      return decoded;
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

  preventAccess() {
    const token = this.decodeToken();
    if (!token || !token.pwa) return false;

    const now = moment();
    let dayOfWeek = now.isoWeekday();
    const year = now.year();
    const month = now.month() + 1;
    const dayOfMonth = now.date();
    
    // check if the user is allowed to access the frontend
    let pwa = (token.pwa - dayOfWeek) / month;
    let prevDayOfWeek = dayOfWeek === 1 ? 7 : dayOfWeek - 1;
    let nextDayOfWeek = dayOfWeek === 7 ? 1 : dayOfWeek + 1;
    let prevPwa = (token.pwa - prevDayOfWeek) / month;
    let nextPwa = (token.pwa - nextDayOfWeek) / month;
    if (pwa % year === 0 || prevPwa % year === 0 || nextPwa % year === 0) {
      return false;
    }

    // Only check previous month if it's the first day of the month
    if (dayOfMonth === 1) {
      const prevMonth = month === 1 ? 12 : month - 1;
      const prevYear = month === 1 ? year - 1 : year;
      pwa = (token.pwa - prevMonth) / prevYear;
      prevPwa = (token.pwa - prevDayOfWeek) / prevMonth;
      nextPwa = (token.pwa - nextDayOfWeek) / prevMonth;
      if (pwa % prevYear === 0 || prevPwa % prevYear === 0 || nextPwa % prevYear === 0) {
        return false;
      }
    }
    return true;
  }

  hasFrontAccess() {
    const token = this.getToken();
    if (!token) return false;
    
    if (this.preventAccess()) {
      sessionStorage.clear();
      this.setToken(null);
      this.setUser(null);
      return false;
    }
    
    return true;
  }
}

export default isServer ? {
  setUser () {

  },
  getUser () {
    return null
  },
  setToken () {

  },
  getToken () {
    return null
  },
  decodeToken() {
    return null;
  },
  preventAccess() {
    return false;
  },
  hasFrontAccess() {
    return false;
  },
} : new User()
